<template>
  <div class="school-data-grade">
    <table class="d-table">
      <thead>
      <tr>
        <th rowspan="2">
          <div class="grade-title">
            <div class="icon__bg-circle" v-if="events.length > 0" @click="isShowMore = !isShowMore"><span class="icon-arrow-down"></span></div>
            {{ calendarName }}
          </div>
        </th>
        <th>Antal skemabrikker</th>
        <th>Antal skemabrikker med vikar</th>
        <th>Antal klokketimer</th>
        <th>Antal klokketimer med vikar</th>
        <th></th>
      </tr>
      <tr>
        <th>{{ events.length }}</th>
        <th>{{ eventsWithSub.length }}</th>
        <th>{{ eventsInHours }}</th>
        <th> {{ eventsWithSubInHours }}</th>
        <th></th>
      </tr>
      </thead>
      <tbody v-if="isShowMore">
      <tr v-for="(subject, prop) in eventsInPools">
        <td>{{ prop }}</td>
        <td>{{ subject['events'] }}</td>
        <td>{{ subject['eventsWithSubs'] }}</td>
        <td>{{ subject['durationInHours'] }}</td>
        <td>{{ subject['durationWithSubsInHours'] }}</td>
        <td></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    calendar: {
      type: Object,
      default: null
    },
    eventsInHash: {
      type: Object,
      default: () => {
      }
    }
  },
  data () {
    return {
      isShowMore: false
    }
  },
  computed: {
    events () {
      return this.eventsInHash[this.calendar.id] ? this.eventsInHash[this.calendar.id] : []
    },
    calendarName () {
      return this.calendar ? this.calendar.name : ''
    },
    eventsInPools () {
      let events = {}
      this.events.forEach(event => {
        if (!events[event.title]) {
          events[event.title] = {
            events: 0,
            eventsWithSubs: 0,
            durations: [0],
            durationsWithSubs: [0]
          }
        }
        events[event.title]['events'] += 1
        events[event.title]['durations'].push(event.v_duration)
        if (event.v_has_substitute) {
          events[event.title]['eventsWithSubs'] += 1
          events[event.title]['durationsWithSubs'].push(event.v_duration)
        }
      })
      for (const key in events) {
        const sumInHours = (events[key]['durations'].reduce((a, b) => a + b)) / 60
        events[key]['durationInHours'] = parseFloat(sumInHours).toFixed(2)
        const sumOfDurationsWithSubs = (events[key]['durationsWithSubs'].reduce((a, b) => a + b)) / 60
        events[key]['durationWithSubsInHours'] = parseFloat(sumOfDurationsWithSubs).toFixed(2)
      }
      return events
    },
    eventsInHours () {
      return this.getEventsInHours(this.events)
    },
    eventsWithSubInHours () {
      return this.getEventsInHours(this.eventsWithSub)
    },
    eventsWithSub () {
      return this.events.filter(event => {
        let hasSub = false
        event.calendars.forEach(calendar => {
          if (calendar.substitute) {
            hasSub = true
          }
        })
        return hasSub
      })
    }
  },
  methods: {
    getEventsInHours (events) {
      const eventsDurations = [0]
      events.forEach(event => {
        eventsDurations.push(event.v_duration)
      })
      const sum = eventsDurations.reduce((a, b) => a + b)
      const inHours = sum / 60
      return parseFloat(inHours).toFixed(2)
    }
  }
}
</script>


<style scoped>
.school-data-grade {
  max-width: 1440px;
  box-shadow: 0 1px 2px rgb(0 0 0 / 7%);
  background: #fff;
  padding: 1rem;
  margin-bottom: 1rem;
}

.school-data-grade__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.d-table {
  width: 100%;
  border-collapse: collapse;
}

.d-table thead {
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: 700;
}

.d-table thead tr:first-child th {
  border-bottom: 1px solid #e2e8f0;
}

.d-table thead tr:first-child th:first-child {
  border-right: 1px solid #e2e8f0;
}

.grade-title {
  display: flex;
  align-items: center;
}

.d-table thead tr th {
  padding: 8px 1rem;
}

.d-table thead tr:first-child th {
  text-transform: uppercase;
  font-weight: bold;
  color: #8898aa;
}

.d-table tbody {
  border: 1px solid #e2e8f0;
}

.d-table tbody tr:first-child td {
  padding: 0.5rem 1rem;
}

.d-table tr:first-child th:first-child,
.d-table tr td:first-child {
  width: 200px;
  text-align: left;
}

.d-table tr td,
.d-table tr th {
  padding: 0 1rem;
  text-align: right;
}

.d-table tbody tr:nth-child(even) {
  background: #f8fafb;
}

.d-table tbody tr:hover:not(:first-child) {
  background: aliceblue;
}
</style>



// WEBPACK FOOTER //
// SchoolDataGrade.vue?787d4156